<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-mt-2">
                <DataTable :value="districts" :lazy="true" :paginator="true" :rows="30" :totalRecords="totalRecords"
                    :loading="loading" @page="onPage($event)" class="p-datatable-users" dataKey="mbz1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h5 class="p-m-0">District</h5>
                        </template>
                        <template v-slot:right>
                            <Button label="Add District" icon="pi pi-plus" @click="toAddDistrict" />
                            <Button label="Filter" icon="pi pi-filter" @click="filterlisting()" 
                                class="p-mr-2" style="margin-left: 0.5rem; "></Button>
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column headerStyle="width: 2%" class="align-center"></Column>
                    <Column field="id" header="Sr." headerStyle="width: 10%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="state" field="mbb5" class="p-text-capitalize" headerStyle="width: 25%">
                    </Column>
                    <Column header="District" field="mbb6" class="p-text-capitalize" headerStyle="width: 25%">
                    </Column>
                    <Column header="Status" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span v-if="data.mbb7 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="data.mbb7 == 0" :class="'user-badge status-temp-suspend'">Inactive</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editdistrictModalOpen(data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <!-- Add Role Dialog starts here -->
    <Dialog v-model:visible="isAddReport" :style="{ width: '800px' }" :modal="true" class="p-fluid"
        header="Add district">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <!-- <div class="p-field p-col-12 p-md-6">
                        <label for="country">
                            Country
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="country" v-model="country" :options="countries" optionLabel="label"
                            placeholder="Select ..." appendTo="body" :filter="true" @change="getStates"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.country.$error">{{ v$.country.$errors[0].$message }}</small>
                    </div> -->
                    <div class="p-field p-col-12 p-md-6">
                        <label for="countrystate">
                            State
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="countrystate" v-model="countrystate" :options="stateList" optionLabel="label"
                            placeholder="Select ..." appendTo="body" :filter="true"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.countrystate.$error">{{ v$.countrystate.$errors[0].$message }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="reportreason">
                            District
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="reportreason" v-model="reportreason" :disabled="!countrystate" required="true" maxlength="100" placeholder="Enter district" 
                            :class="{ 'p-invalid': isSubmitted && !reportreason }" />
                        <small class="p-invalid p-error" v-if="v$.reportreason.$error">{{
                            v$.reportreason.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :disabled="!isEditUserRole"
                            :options="adminstatusList" optionLabel="label" placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addDistrict" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Add Role Dialog ends here -->

    <!-- Edit Role Dialog starts here -->
    <Dialog v-model:visible="isEditUserRole" header="Edit district" :style="{ width: '800px' }" :modal="true"
        class="p-fluid">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <!-- <div class="p-field p-col-12 p-md-6">
                        <label for="country">
                            Country
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="country" v-model="country" :options="countries" optionLabel="label"
                            placeholder="Select ..." appendTo="body" :filter="true" @change="getStates"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.country.$error">{{ v$.country.$errors[0].$message }}</small>
                    </div> -->
                    <div class="p-field p-col-12 p-md-6">
                        <label for="countrystate">
                            State
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="countrystate" v-model="countrystate" :options="stateList" optionLabel="label"
                            placeholder="Select ..." appendTo="body" :filter="true"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.countrystate.$error">{{ v$.countrystate.$errors[0].$message }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="reportreason">
                            District
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="reportreason" v-model="reportreason" required="true" maxlength="100" placeholder="Enter district" 
                            :class="{ 'p-invalid': isSubmitted && !reportreason }" />
                        <small class="p-invalid p-error" v-if="v$.reportreason.$error">{{
                            v$.reportreason.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus"
                            :options="adminstatusList" optionLabel="label" placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="editState(rowData)" style="width: 90px;"></Button>
        </template>
    </Dialog>

    <!-- Filter dialog start here -->
    <Dialog v-model:visible="isFilter" :style="{ width: '600px' }" header="District Filter" :modal="true"
        class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-6">
                    <label for="districtfilter"> District</label>
                    <Dropdown id="districtfilter" v-model="districtFilter" :options="districtFilterList" optionLabel="label"
                    placeholder="Select ..." appendTo="body" :filter="true"></Dropdown>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Status</label>
                    <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                        placeholder="Select ..." appendTo="body">
                    </Dropdown>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Reset" icon="pi pi-refresh" class="p-button-text" @click="reSetFilteredData()" />
            <Button label="Search" icon="pi pi-search" class="p-mr-2" autofocus @click="submitFilter" />
        </template>
    </Dialog>
    <!-- Filter dialog end here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useConfirm } from "primevue/useconfirm";
import { required, helpers } from '@vuelidate/validators';

export default {
    data() {
        return {
            confirm: useConfirm(),
            districts: [],
            v$: useValidate(),
            isAddReport: false,
            isSubmitted: false,
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            isEditUserRole: false,
            showLoaderAddBtn: false,
            rowId: '',
            reportreason: '',
            countries: [],
            countrystate: '',
            country: '',
            stateList: [],
            adminstatus: { label: 'Active', value: 1 },
            adminstatusList: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 0 },
            ],
            isFilter: false,
            districtFilter: '',
            districtFilterList : [],
        };
    },
    validations() {
        return {
            reportreason: { required: helpers.withMessage('Please enter district', required) },
            adminstatus: { required: helpers.withMessage('Please select admin status', required) },
            countrystate: { required: helpers.withMessage('Please select state', required) },
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        this.loading = true;
        this.getAllDistricts({ page_no: this.page_no });
        this.getCountries();
        this.getStates();
    },
    methods: {
        getCountries() {
            this.ApiService.getCountries().then((items) => {
                if (items.status === 200) {
                    this.countries = items.data;
                }
            })
        },
        getStates() {
            this.ApiService.getStates({ mak2: this.country.value } ).then((items) => {
                if (items.status === 200) {
                    this.stateList = items.data;
                }
            })
        },
        getAllDistricts(e) {
            e.page_no = this.page_no;
            this.ApiService.getAllDistricts(e).then((items) => {
                if (items.status === 200) {
                    this.districts = items.data;
                    this.totalRecords = items.count;
                    this.isFilter = false;
                } else {
                    this.districts = [];
                }
                this.loading = false;
            });
        },
        async toAddDistrict() {
            this.isAddReport = true;
            this.isSubmitted = false;
            this.country = '';
            this.reportreason = '';
            this.districtcode = '';
            this.countrystate = '';
            this.adminstatus = { label: 'Active', value: 1 };
            this.v$.$reset();
        },
        addDistrict() {
            this.submitted = true;
            this.errormsg = '';
            this.v$.$validate();
            let formData = new FormData();
            formData.append('mbb2', this.country.value);
            formData.append('mbb3', this.country.label);
            formData.append('mbb4', this.countrystate.value);
            formData.append('mbb5', this.countrystate.label);
            formData.append('mbb6', this.reportreason);
            formData.append('mbb7', this.adminstatus.value);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateDistricts(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getAllDistricts({ page_no: this.page_no });
                        this.isAddReport = false;
                        this.reportreason = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        editdistrictModalOpen(data) {
            this.isEditUserRole = true;
            this.reportreason = '';
            this.country = '';
            this.countrystate = '';
            this.adminstatus = '',
            this.rowId = data.mbb1;
            this.reportreason = data.mbb6;
            this.country = this.countries.find((item) => item.label == data.mbb3);
            this.countrystate = { label: data.mbb5, value: data.mbb4 };
            this.adminstatus = this.adminstatusList.find((item) => item.value == data.mbb7);
        },
        editState() {
            this.submitted = true;
            this.errormsg = '';
            let formData = new FormData();
            formData.append('mbb1', this.rowId);
            formData.append('mbb2', this.country?.value);
            formData.append('mbb3', this.country?.label);
            formData.append('mbb4', this.countrystate?.value);
            formData.append('mbb5', this.countrystate?.label);
            formData.append('mbb6', this.reportreason);
            formData.append('mbb7', this.adminstatus?.value);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateDistricts(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getAllDistricts({ page_no: this.page_no });
                        this.isEditUserRole = false;
                        this.reportreason = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getAllDistricts({ page_no: event.page });
        },
        getDistricts() {
            this.ApiService.getDistricts().then((items) => {
                if (items.status === 200) {
                    this.districtFilterList = items.data;
                }
            })
        },
        reSetFilteredData() {
            this.getAllDistricts({ page_no: this.page_no });
            this.isFilter = false;
            this.districtFilter = '';
            this.adminstatus = { label: 'Active', value: 1 };
            // this.showFillFilter = false;
        },
        filterlisting() {
            this.isFilter = true;
            this.adminstatus = { label: 'Active', value: 1 };
            this.getDistricts();
        },
        submitFilter() {
            this.showFillFilter = true;
            this.getAllDistricts({ mbb6: this.districtFilter.label, mbb7: this.adminstatus.value });
        },
    }
};
</script>